import { MTableToolbar } from '@material-table/core';
import BaseTable from 'components/Tables/BaseTable';
import { sortBy } from 'lodash';
import HeaderWSelectors from 'pages/Flows/HeaderWSelectors';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import docDefinition from 'reports/flows/flowScenarios';
import { groupBy } from 'selectors/generic';
import theme from 'source/theme';
import { PROC_TAB } from 'utils/constants/descriptorTypes';
import { lcsTranslator } from 'utils/constants/lcsTypes';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/flowSteps';
import { TABLE_HEIGHT } from 'utils/ui/constants';
import TabsBar from '../TabsBar';
import { currentUser } from 'selectors/currentUser';

pdfMake.addVirtualFileSystem(pdfFonts);

// `flow.steps` is a list of ids now, and `step.substeps` is gone; both come out
// of the steps slice, indexed by the column that used to be the nesting.
const stepsByFlow = groupBy('steps', 'flow_id');
const substepsByMasterStep = groupBy('steps', 'master_step_id');

const Component = props => {
  const {
    conditions, descriptors, flows, flow, lcsById, lcs, scenario,
    scenarioDescriptors, scenarioDescriptorConditions, stepRawMaterials,
    stepsById, stepsByFlow, substepsByMasterStep, units, user
  } = props;
  const { backToScenarios, setDescriptorTab, setFlow, setLcs, setStepId } = props;
  const tableRef = React.useRef(null);

  /**
   * Error alert computation
   */
  const stepsOfFlow = stepsByFlow[flow.id] || [];
  const stepsToTest = stepsOfFlow.map(step => step.id);
  const matchingSteps = stepRawMaterials
    .filter(srm =>
      srm.descriptors && srm.descriptors.includes(lcsTranslator[lcs.id]) && stepsToTest.includes(srm.step_id)
    )
    .map(srm => srm.step_id);

  const matchingStepsSet = new Set(matchingSteps);
  /**
   * Error alert computation --- END
   */

    // Taking out Master steps with sub steps
  const flowSteps = [];
  stepsOfFlow.forEach(step => {
    if ((substepsByMasterStep[step.id] || []).length === 0) {
      if (step.master_step_id) {
        flowSteps.push({
          ...step,
          step_name: stepsById[step.master_step_id].name,
          step_description: stepsById[step.master_step_id].description,
          substep_name: step.name,
          substep_description: step.description
        });
      } else {
        flowSteps.push({
          ...step,
          step_name: step.name,
          step_description: step.description,
        });
      }
    }
  });

  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    const preSelectedSteps = new Set();
    scenarioDescriptors
      .filter(fsd => flowSteps.map(fs => fs.id).includes(fsd.step_id))
      .forEach(fsd => preSelectedSteps.add(fsd.step_id));
    setSelectedIds(Array.from(preSelectedSteps));
  }, [scenarioDescriptors]);


  // TODO Adding Checked info to table, there should be a better way
  const checkedSteps = flowSteps.map(fs =>
    selectedIds.includes(fs.id) ?
      { ...fs, tableData: { checked: true } } :
      { ...fs, tableData: { checked: false } }
  );
  const orderedCheckedSteps = sortBy(checkedSteps, [row => !selectedIds.includes(row.id), 'id']);

  const exportPDF = [
    {
      position: 'toolbarOnSelect',
      icon: tableIcons.Pdf,
      tooltip: 'Exportar PDF',
      onClick: () => {
        pdfMake.createPdf(
          docDefinition(lcs, flow, descriptors, conditions, scenario,
            scenarioDescriptors, scenarioDescriptorConditions, units))
          .open();
      }
    },
    {
      position: 'toolbar',
      icon: tableIcons.Pdf,
      tooltip: 'Exportar PDF',
      onClick: () => {
        pdfMake.createPdf(
          docDefinition(lcs, flow, descriptors, conditions, scenario,
            scenarioDescriptors, scenarioDescriptorConditions, units))
          .open();
      }
    }
  ];

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        titleBack={true}
        titleAction={backToScenarios}
        title={
          <HeaderWSelectors
          disabled={true}
          currentOptionFlow={flow}
          currentOptionLcs={lcs}
          currentOptionScenario={scenario}
          />
        }
        columns={columns(user)}
        data={orderedCheckedSteps}
        order={false}
        onRowClick={() => null}
        onRowDoubleClick={rowData => setStepId(rowData.id)}
        paging={false}
        options={{
          maxBodyHeight: TABLE_HEIGHT(false, 48),
          minBodyHeight: TABLE_HEIGHT(false, 48),
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false,
          selectionProps: {
            disabled: true
          },
          rowStyle: rowData => ({
            backgroundColor: !rowData.tableData.checked && matchingStepsSet.has(rowData.id) ?
              theme.palette.rowErrorBackground.main : ''
          })
        }}
        actions={
          [
            {
              icon: tableIcons.Descriptors,
              tooltip: 'Gerir descritores',
              onClick: (event, rowData) => setStepId(rowData.id),
              position: 'row'
            },
            ...exportPDF
          ]
        }
        components={{
          Toolbar: props => (
            <div style={{ backgroundColor: theme.palette.background.veryLight }}>
              <MTableToolbar {...props} />
              <TabsBar value={PROC_TAB} setValue={setDescriptorTab}/>
            </div>
          )
        }}
      />
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  conditions: state.conditions,
  descriptors: state.descriptors,
  lcsById: state.descriptors.models,
  flows: state.flows,
  units: state.units.models,
  scenarioDescriptorConditions: state.scenarioDescriptorConditions.data,
  stepRawMaterials: state.stepRawMaterials.data,
  stepsById: state.steps.models,
  stepsByFlow: stepsByFlow(state),
  substepsByMasterStep: substepsByMasterStep(state),
  user: currentUser(state)
});

export default connect(mapStateToProps)(Component);
